import { createSlice } from "@reduxjs/toolkit";

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    SolicitudesXedad: [],
    SolicitudesXedadLoading: false,
    SolicitudesXentidad: [],
    SolicitudesXentidadLoading: false,
    SolicitudescomoEnteraron: [],
    SolicitudescomoEnteraronLoading: false,
    SolicitudesSexo: [],
    SolicitudesSexoLoading: false,
    SolicitudesTerapia: [],
    SolicitudesTerapiaLoading: false,
    SolicitudesAuxAuditivo: [],
    SolicitudesAuxAuditivoLoading: false,
    SolicitudesTamiz: [],
    SolicitudesTamizLoading: false,
    ResumenSolicitudes: {
      numSolicitudes: 0,
      numExpedientes: 0,
    },
    ResumenSolicitudesLoading: false,
  },
  reducers: {
    GetSolicitudesXentidad: (state, action) => {
      state.SolicitudesXentidad = action.payload;
      state.SolicitudesXentidadLoading = false;
    },
    GetSolicitudesXentidadLoading: (state) => {
      state.SolicitudesXentidadLoading = true;
    },
    GetSolicitudescomoEnteraron: (state, action) => {
      state.SolicitudescomoEnteraron = action.payload;
      state.SolicitudescomoEnteraronLoading = false;
    },
    GetSolicitudescomoEnteraronLoading: (state) => {
      state.SolicitudescomoEnteraronLoading = true;
    },
    GetSolicitudesSexo: (state, action) => {
      state.SolicitudesSexo = action.payload;
      state.SolicitudesSexoLoading = false;
    },
    GetSolicitudesSexoLoading: (state) => {
      state.SolicitudesSexoLoading = true;
    },
    GetSolicitudesTerapia: (state, action) => {
      state.SolicitudesTerapia = action.payload;
      state.SolicitudesTerapiaLoading = false;
    },
    GetSolicitudesTerapiaLoading: (state) => {
      state.SolicitudesTerapiaLoading = true;
    },
    GetSolicitudesAuditivo: (state, action) => {
      state.SolicitudesAuxAuditivo = action.payload;
      state.SolicitudesAuxAuditivoLoading = false;
    },
    GetSolicitudesAuditivoLoading: (state) => {
      state.SolicitudesAuxAuditivoLoading = true;
    },
    GetSolicitudesTamiz: (state, action) => {
      state.SolicitudesTamiz = action.payload;
      state.SolicitudesTamizLoading = false;
    },
    GetSolicitudesTamizLoading: (state) => {
      state.SolicitudesTamizLoading = true;
    },
    GetSolicitudesEdad: (state, action) => {
      state.SolicitudesXedad = action.payload;
      state.SolicitudesXedadLoading = false;
    },
    GetSolicitudesEdadLoading: (state) => {
      state.SolicitudesXedadLoading = true;
    },
    GetResumenSolicitudes: (state, action) => {
      state.ResumenSolicitudes = action.payload;
      state.ResumenSolicitudesLoading = false;
    },
    GetResumenSolicitudesLoading: (state) => {
      state.ResumenSolicitudesLoading = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  GetSolicitudesXentidad,
  GetSolicitudesXentidadLoading,
  GetSolicitudescomoEnteraron,
  GetSolicitudescomoEnteraronLoading,
  GetSolicitudesSexo,
  GetSolicitudesSexoLoading,
  GetSolicitudesTerapia,
  GetSolicitudesTerapiaLoading,
  GetSolicitudesAuditivo,
  GetSolicitudesAuditivoLoading,
  GetSolicitudesTamiz,
  GetSolicitudesTamizLoading,
  GetSolicitudesEdad,
  GetSolicitudesEdadLoading,
  GetResumenSolicitudes,
  GetResumenSolicitudesLoading,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
